const savedContentPopupOpenTarget = 'a.wm-savedContentOpenPopup';
const savedContentPopupCloseTarget = 'div.wm-popup__savedContentCloseButton > i';
const optionBoxTarget = 'div.wm-optionBox';
jQuery(document).on('ready', function () {
    var savedContentPopup = document.getElementById("savedContentPopup");
    if (jQuery(optionBoxTarget).length > 0) {
        let currentPageURL = window.location.href.split('#')[0];
        jQuery('.wm-optionBox .wm-savedContentOpenPopup').attr('data-path', currentPageURL);
    }
    jQuery(savedContentPopupCloseTarget).click(function () {
        if (jQuery('#savedContentPopup.-show').length > 0) {
            savedContentPopup.classList.toggle("-show");
        }
    });
});
